module.exports = __webpack_public_path__ + "static/shield-78e5826574234464d93edc2a85b5f6c7.webm";